export default "/images/framework/MissionLink.f7f68e93.svg?f7f68e93";